import * as borogove from "borogove";
import { useRef, useState } from "react";
import { Button, IconButton, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/ModeEdit";

import { Profile } from "./Profile";
import { EditProfile } from "./EditProfile";

export const EditableProfile = ({
	initial,
	saveProfile,
}: {
	initial: borogove.Profile;
	saveProfile: (builder: borogove.ProfileBuilder) => void;
}) => {
	const editProfileRef = useRef<HTMLFormElement | null>(null);
	const [profile, setProfile] = useState(initial);
	const [editing, setEditing] = useState(false);

	return (
		<>
			{!editing && (
				<IconButton title="Edit Profile" onClick={() => setEditing(true)}>
					<EditIcon />
				</IconButton>
			)}
			{!editing && <Profile profile={profile} />}
			{editing && (
				<form method="dialog" ref={editProfileRef}>
					<Stack spacing={2}>
						<EditProfile profile={profile} setProfile={setProfile} />
						<Stack direction="row" spacing={1} alignItems="center">
							<Button
								variant="outlined"
								color="error"
								onClick={() => {
									setProfile(initial); // Undo edits
									setEditing(false);
								}}
								fullWidth
							>
								Cancel
							</Button>
							<Button
								fullWidth
								variant="contained"
								type="submit"
								onClick={() => {
									if (editProfileRef.current?.reportValidity()) {
										saveProfile(new borogove.ProfileBuilder(profile));
										setEditing(false);
									}
								}}
							>
								Save
							</Button>
						</Stack>
					</Stack>
				</form>
			)}
		</>
	);
};
